import { TApiDatetime } from '../../types/api/TApiDatetime';
import { TApiPager } from '../../types/api/TApiPager';
import { TAppContentType } from '../../types/TAppContentType';

export interface AuthHeaders {
  Authorization: string;
}

/** 一覧APIの本文取得区分: none=取らない / all=全行 / video=動画のみ */
export const INCLUDE_CONTENT = {
  none: 'none',
  all: 'all',
  video: 'video',
} as const;

export type IncludeContentMode =
  typeof INCLUDE_CONTENT[keyof typeof INCLUDE_CONTENT];

type Query = {
  content_type_id?: TAppContentType[];
  category_id?: number;
  title?: string;
  slug?: string;
  skip?: number;
  limit?: number;
  recommended_flg?: boolean;
  content?: string;
  category_flg?: boolean;
  include_content?: IncludeContentMode;
};

type Content = {
  id: number;
  site_id: number;
  content_type_id: number;
  external_public_flg: string;
  title: string;
  post_date: TApiDatetime;
  public_start_date: TApiDatetime;
  public_end_date: TApiDatetime;
  is_public: boolean;
  is_external_public: boolean;
  slug: string;
  public_status: string;
  img_url: string | null;
  content: string | null;
  user_id: number;
  category_id: number;
  created_at: TApiDatetime;
  updated_at: TApiDatetime;
  deteled_at: TApiDatetime;
  like_count: number;
  like_active: boolean;
  like_flg: boolean;
  bookmark_flg: boolean;
};

export type TContentsResponse = TApiPager & { contents: Content[] };

export type Methods = {
  get: {
    query?: Query;
    reqHeaders?: AuthHeaders;
    resBody: TContentsResponse;
  };
};
